module.exports = __webpack_public_path__ + "static/img/follow.b1ca2db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/follow.jpg
// module id = XqC8
// module chunks = 1